exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.traffic-chart {\n  position: relative;\n}\ndiv.traffic-chart div.edit-annotations {\n  position: absolute;\n  right: 0;\n  top: -3.2rem;\n}\ndiv.traffic-chart div.edit-annotations.editing {\n  top: -8rem;\n}\ndiv.traffic-chart div.edit-annotations svg {\n  width: 2.4rem;\n  cursor: pointer;\n}\ndiv.traffic-chart div.edit-annotations span.edit-annotations {\n  display: inline-block;\n  float: right;\n  margin-right: 1.5rem;\n}\ndiv.traffic-chart div.v-select {\n  width: 17rem;\n}", ""]);

// exports
